var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningParam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9133_96699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4174 37.6334L9.97677 37.6453C8.39744 37.6453 6.98177 36.8238 6.19309 35.4486C5.79875 34.76 5.59961 34.006 5.59961 33.2499C5.59961 32.4939 5.79678 31.7398 6.19112 31.0512L21.9016 2.26805C22.6902 0.890897 24.1059 0.0693708 25.6852 0.0673864C27.2646 0.065402 28.6802 0.888912 29.4689 2.26408L45.2011 31.0393C45.5954 31.7259 45.7926 32.48 45.7926 33.2341C45.7926 33.9881 45.5954 34.7441 45.2011 35.4327C44.4124 36.8099 42.9967 37.6314 41.4174 37.6334ZM5.99592 33.2479C5.99592 33.9345 9.4661 32.4542 9.82495 33.0793C10.5446 34.3314 8.54137 37.2464 9.97874 37.2464C9.97874 37.2464 44.1423 36.4864 44.86 35.2343C45.2188 34.6072 45.3982 33.9206 45.3982 33.2341C45.3982 32.5475 45.2188 31.8609 44.858 31.2338L29.1258 2.45855C28.4082 1.21038 27.1226 0.462276 25.6852 0.462276C24.2499 0.462276 5.99592 32.5594 5.99592 33.246V33.2479Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.766 37.2355C41.3717 38.0293 59.8287 37.7852 60.0475 37.7852C60.0475 37.7852 65.2351 37.6701 65.3435 37.4796C65.3987 37.3844 65.4243 37.2792 65.4243 37.176C65.4243 37.0728 65.3967 36.9676 65.3415 36.8724L62.9518 32.5028C62.8434 32.3123 62.6482 32.1992 62.4293 32.1992C62.4195 32.1992 62.4076 32.2072 62.3899 32.223C59.2036 35.0885 55.276 36.9835 51.0014 37.047C46.4566 37.1145 41.7877 37.1839 41.7621 37.2336L41.766 37.2355Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8602 31.2852C42.8094 31.2852 49.2535 24.7997 49.2535 16.7993C49.2535 8.79902 42.8094 2.31348 34.8602 2.31348C26.9109 2.31348 20.4668 8.79902 20.4668 16.7993C20.4668 24.7997 26.9109 31.2852 34.8602 31.2852Z",
    fill: "#FF6F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8621 25.6786C35.5916 25.6786 36.1831 25.0833 36.1831 24.3491C36.1831 23.6148 35.5916 23.0195 34.8621 23.0195C34.1325 23.0195 33.541 23.6148 33.541 24.3491C33.541 25.0833 34.1325 25.6786 34.8621 25.6786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8563 7.91877C34.734 8.73037 34.9529 8.90103 34.9529 12.4014C34.9529 15.9019 35.6765 20.5949 34.8602 20.5949C34.0439 20.5949 33.7462 10.9112 30.9129 10.0539C27.5827 9.04589 35.2486 5.29346 34.8543 7.92076L34.8563 7.91877Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9133_96699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningParam);
export default __webpack_public_path__ + "static/media/warningParam.0d6f7810a88942b099e5f8d44e037139.svg";
export { ForwardRef as ReactComponent };